module.exports = __webpack_public_path__ + "static/media/animalCiclo3.9b80a599.png";